export type ClientLinkCreateRequest = {
  orgId: string;
  inwards: string;
  outwards: string;
  isAdvanced?: boolean;
  sharedCustomFields?: string[];
};

export type ClientLinkUpdateByIdRequest = ClientLinkCreateRequest & {
  _id: string;
};

export type ClientLinkUpdateResponse = {
  _id: string;
  created?: string;
  updated?: string;
} | null;

export type ClientLinkCreateResponse = {
  item: {
    _id?: string;
    created?: string;
    updated?: string;
  };
};

export function useApiClientLink() {
  const { $client } = useNuxtApp();

  const updateById = async (
    request: ClientLinkUpdateByIdRequest
  ): Promise<ClientLinkUpdateResponse> => {
    const response = await $client.clientLink.updateById.mutate(request);

    return response;
  };

  const create = async (
    request: ClientLinkCreateRequest
  ): Promise<ClientLinkCreateResponse> => {
    const response = await $client.clientLink.create.mutate(request);

    return response;
  };

  return { updateById, create };
}
